import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControlErrorMessagesModule} from "../../../../../pipes/form-control-error-messages/form-control-error-messages.module";
import {NgClass, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ProfileHttpService} from "../../../../../services/http-services/profile/profile-http.service";
import {SpinnerComponent} from "../../../../../shared-components/spinner/spinner.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'tl-edit-profile-username',
  templateUrl: './edit-profile-username.component.html',
  imports: [
    FormControlErrorMessagesModule,
    NgIf,
    ReactiveFormsModule,
    NgClass,
    SpinnerComponent,
    TranslateModule
  ],
  standalone: true
})
export class EditProfileUsernameComponent implements OnInit, OnChanges{
  @Input() profileData: any;
  @Output() changeProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelChanges: EventEmitter<void> = new EventEmitter<void>();
  isSpinnerActive = false;
  formTriedToSubmit = false;
  editProfileUsernameForm!: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private profileHttpService: ProfileHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileDate && changes.profileData.currentValue) {
      this.editProfileUsernameForm.patchValue(changes.profileData.currentValue);
    }
  }

  buildForm(): void {
    this.editProfileUsernameForm = this.formBuilder.group({
      username: ['', [Validators.required]],
    });
    this.editProfileUsernameForm.patchValue(this.profileData);
  }

  onCancelChanges(): void {
    this.editProfileUsernameForm.reset();
    this.editProfileUsernameForm.patchValue(this.profileData);
    this.cancelChanges.emit();
  }

  onSubmitEditProfileNameForm(): void {
    this.formTriedToSubmit = false;
    if (this.editProfileUsernameForm.valid) {
      this.isSpinnerActive = true;
      this.profileHttpService.editProfileUsername(this.editProfileUsernameForm.value).then(res => {
        this.isSpinnerActive = false;
        this.changeProfile.emit(res.data);
        this.toastService.success(res.message);
      }).catch((error) => {
        this.isSpinnerActive = false;
        if (error.error.code === 403) {
          this.toastService.error();
        } else {
          Object.values(error.error.data).forEach((value: any) => this.toastService.error());
        }
      });
    }
  }
}
